import { useTranslation } from 'react-i18next'

import { Envelope } from '@phosphor-icons/react'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const SendInstructionsTitle = () => {
  const { t } = useTranslation()

  return (
    <Styles.ActionTitleContainer>
      <Envelope size={16} />
      <Text type="bodyMRegular">{t('Reenviar instrucciones de devolución')}</Text>
    </Styles.ActionTitleContainer>
  )
}

export default SendInstructionsTitle
